import React from "react"

import { graphql, useStaticQuery } from "gatsby"
import Image from "gatsby-plugin-sanity-image"
import PropTypes from "prop-types"

import * as styles from "./newsletter-top-level.module.scss"
import isRegion from "../../../helpers/newsletter-region"
import { dateString } from "../../../helpers/portable-text-mapping"
import CopyContainer from "../../atoms/copy-container"
import Heading from "../../atoms/heading"
import Wrapper from "../../atoms/wrapper"

const NewsletterTopLevel = ({ section, country, city, segment }) => {
  const { allSanityDictionary, sanitySettings } = useStaticQuery(graphql`
    {
      allSanityDictionary {
        nodes {
          key {
            current
          }
          value
        }
      }
      sanitySettings {
        default_images {
          logo {
            ...ImageWithPreview
          }
        }
      }
    }
  `)

  const color =
    section.special_edition || section.styling === "special_edition"
      ? section.vertical.special_color
      : section.vertical.color

  const presentingPartner = section.presenting_partners?.find((p) =>
    p.country
      ? p.country.abbreviation === country
      : isRegion(p, country, city, segment)
  )

  return (
    <div className={section.headliner ? styles.topLevel : ""}>
      {section.issue_number ? (
        <div
          className={`${styles.headliner} ${styles[`headliner__${color.replaceAll("-", "")}`]}`}
        >
          {section.headliner ? `${section.headliner} •${" "}` : ""}
          {
            allSanityDictionary.nodes.find(
              (item) => item.key.current === "edition"
            )?.value
          }{" "}
          #{section.issue_number} •{" "}
          {section.date ? dateString(section.date, true) : ""}
        </div>
      ) : (
        ""
      )}

      <Wrapper newsletter className={styles.grid}>
        <div
          className={`${styles.left} ${section.styling === "lifestyle" ? styles.left__lifestyle : ""}`}
        >
          {section.logo ? (
            <Image {...section.logo} alt="" />
          ) : (
            <Image {...sanitySettings.default_images.logo} alt="" />
          )}
        </div>
        <CopyContainer
          className={`${styles.right} ${section.styling === "lifestyle" ? styles.right__lifestyle : ""}`}
        >
          {presentingPartner ? (
            <>
              <div className={styles.small}>
                {presentingPartner.partner.prefix ||
                  allSanityDictionary.nodes.find(
                    (item) => item.key.current === "partner_presenting"
                  )?.value}
              </div>
              <a
                className={`${styles.partner} ${presentingPartner.contain ? styles.partner__contain : ""}`}
                href={presentingPartner.url || presentingPartner.partner.url}
              >
                <Image
                  {...presentingPartner.partner.logo}
                  className={`${styles.partnerLogo} ${section.styling === "lifestyle" ? styles.partnerLogo__lifestyle : ""}`}
                  width={300}
                />
              </a>
            </>
          ) : (
            <Heading level={4}>
              <div
                dangerouslySetInnerHTML={{
                  __html: allSanityDictionary.nodes.find(
                    (item) => item.key.current === "tagline"
                  )?.value,
                }}
              />
            </Heading>
          )}
        </CopyContainer>
      </Wrapper>
    </div>
  )
}

export default NewsletterTopLevel

NewsletterTopLevel.propTypes = {
  section: PropTypes.object.isRequired,
  country: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  segment: PropTypes.string.isRequired,
}
